import React, { Fragment, useContext } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from "@material-ui/core";
import { DesignContext } from "../context/design";
import {
  CableTypeList,
  workFuncList,
  RelayTypeList,
  SwitchTypeList,
  MeterTypeList,
} from "../constant/equip-options";
import { Delete } from "@material-ui/icons";

const useStyle = makeStyles((theme: Theme) => ({
  list: {
    paddingRight: theme.spacing(1),
  },
  deleteIcon: { color: theme.palette.error.main },
  noEquipGrid: { display: "flex", justifyContent: "center" },
}));

const EquipEdit = () => {
  const classes = useStyle();
  const { map, event, setevent } = useContext(DesignContext);
  const { designEquips } = event;

  const _removeEquip = (fid: string) => (e: any) => {
    const removedEquip = designEquips.filter(
      (eq: any) => eq.id !== `equip-${fid}`
    );

    map?.removeLayer(`equip-${fid}`);
    map?.removeSource(`equip-${fid}`);
    setevent({ ...event, designEquips: removedEquip });
  };

  const genTitleEquip = (prop: any) => {
    let title;
    if (prop.properties.equip_type === "equip-cable") {
      title = `Cable ${
        CableTypeList.find((ct) => ct.value === prop.properties.cableType)
          ?.label
      } (${
        workFuncList.find((wf) => wf.value === prop.properties.workFunc)?.label
      })`;
    } else if (prop.properties.equip_type === "equip-pole") {
      title = `Pole${prop.properties.lamp ? `- lamp` : ""}${
        prop.properties.ground ? `- ground` : ""
      } (${
        workFuncList.find((wf) => wf.value === prop.properties.workFunc)?.label
      })`;
    } else if (prop.properties.equip_type === "equip-relay") {
      title = `Relay - ${
        RelayTypeList.find((rt: any) => rt.value === prop.properties.relayType)
          ?.label
      } (${
        workFuncList.find((wf) => wf.value === prop.properties.workFunc)?.label
      })`;
    } else if (prop.properties.equip_type === "equip-transformer") {
      title = `Transformer (${
        workFuncList.find((wf) => wf.value === prop.properties.workFunc)?.label
      })`;
    } else if (prop.properties.equip_type === "equip-switch") {
      title = `Switch - ${
        SwitchTypeList.find((st) => st.value === prop.properties.switchType)
          ?.label
      } (${
        workFuncList.find((wf) => wf.value === prop.properties.workFunc)?.label
      })`;
    } else if (prop.properties.equip_type === "equip-meter") {
      title = `Meter - ${
        MeterTypeList.find((mt) => mt.value === prop.properties.meterType)
          ?.label
      } (${
        workFuncList.find((wf) => wf.value === prop.properties.workFunc)?.label
      })`;
    } else if (prop.properties.equip_type === "equip-riser-transformer") {
      title = `Riser Transformer (${
        workFuncList.find((wf) => wf.value === prop.properties.workFunc)?.label
      })`;
    }
    return title;
  };

  const _getDataToEdit = (equipData: any) => () => {
    const mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    draw.add(equipData);
    mapEvent.setLayoutProperty(`equip-${equipData.id}`, "visibility", "none");
    draw.changeMode(draw.modes.SIMPLE_SELECT, {
      featureIds: [equipData.id],
    });
    setevent({
      ...event,
      type: equipData.properties.equip_type,
      feature: equipData,
    });
  };

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle1">Electric Device List</Typography>
        </Grid>
        {Boolean(designEquips.length) ? (
          <Grid item xs={12}>
            <List className={classes.list}>
              {designEquips.map((equip: any) => {
                return (
                  <ListItem
                    key={equip.id}
                    button
                    onClick={_getDataToEdit(equip.source.data)}
                  >
                    <ListItemText primary={genTitleEquip(equip.source.data)} />
                    <ListItemSecondaryAction>
                      <IconButton onClick={_removeEquip(equip.source.data.id)}>
                        <Delete className={classes.deleteIcon} />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        ) : (
          <Grid item xs={12} className={classes.noEquipGrid}>
            <Typography variant="body1" color="textSecondary">
              No Equip
            </Typography>
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
};

export default EquipEdit;
